export type AddStoreType = {
  active: boolean;
  name: string;
  type: string;
  logo: string;
  location: string;
  metadata: {
    inventory: boolean;
    manageRequests: boolean;
    procurement: boolean;
    wasteReport: boolean;
    vendors: boolean;
    trash: boolean;
  };
};
export type StoreType = AddStoreType & {
  id: string;
  updated_at: string;
  created_at: string;
};
export const initStoreModal = {
  type: '',
  logo: '',
  location: '',
  name: '',
  active: false,
  metadata: {
    inventory: false,
    manageRequests: false,
    procurement: false,
    wasteReport: false,
    vendors: false,
    trash: false
  }
};
